// extracted by mini-css-extract-plugin
export var contentBody = "_5c-9";
export var headerImage = "_5c-2";
export var imageButton = "_5c-7";
export var imageButtonIcon = "_5c-8";
export var imageHeader = "_5c-4";
export var imageHeaderText = "_5c-5";
export var imageOverlay = "_5c-3";
export var imageTitle = "_5c-6";
export var imageWrapper = "_5c-1";
export var taskList = "_5c-a";
export var widget = "_5c-0";